// extracted by mini-css-extract-plugin
export default {"container":"style_container__1tfMn","text":"style_text__5pkVe","wrapper":"style_wrapper__3hrqc"};